import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Controller, Autoplay } from 'swiper'
import { MenuItemType } from '@next-nx/utils/types'
import { WImage } from '@next-nx/shared-ui/atoms'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './Hero.module.sass'
import {
  AutoIllustration,
  ScenarioPalazziIllustration,
  HeroElettricoIllustration,
} from '@next-nx/shared-ui/icons'
import { NUOVAMOBILITA } from '@next-nx/utils/settings'
SwiperCore.use([Controller, Pagination, Autoplay])

interface Props {
  item?: MenuItemType | undefined
  home?: boolean
  className?: string
  site?: string
  contentClassName?: string
}

const Hero = (props: Props) => {
  const { item = undefined, home = false, className = '', site = '', contentClassName = '' } = props

  const { linkDataLayer } = useTealium()
  const [slidesSeen, setSlidesSeen] = useState<number[]>([])

  const handleTracking = (action_type: string) => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'navigazione',
      action_tech: 'click',
      action_type: action_type?.replace(/ /g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'interazione_componente_banner',
    })
  }

  return item ? (
    <div
      className={`${styles.hero} ${home ? styles['hero--home'] : ''} ${
        item.children?.edges?.length === 1 ? styles['hero--single-slide'] : ''
      } ${item.style === 'transparency' ? styles[`hero--transparency`] : ''} ${className}`}
    >
      <div className={styles.slider}>
        <Swiper
          slidesPerView={1}
          watchOverflow
          pagination={{ clickable: true }}
          className="swiper--negative"
          onSlideChange={(swiper) => {
            if (!slidesSeen.includes(swiper?.activeIndex)) {
              // con scorrimento automatico, il tracciamento scatta solo una volta per slide
              setSlidesSeen([...slidesSeen, swiper?.activeIndex])
              handleTracking('swipe_banner')
            }
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
        >
          {item.children?.edges.map((x) => (
            <SwiperSlide key={x.node.pk}>
              <div className={styles.item}>
                {x.node?.style === 'icons' && (
                  <span className={styles.car}>
                    <AutoIllustration />
                  </span>
                )}
                <div className={`${styles.content} ${contentClassName ? contentClassName : ''}`}>
                  <p
                    className={`${styles.title} ${
                      x.node.nameMobile ? styles['title--desktop'] : ''
                    }`}
                  >
                    {x.node.name}
                  </p>
                  {!!x.node.nameMobile && (
                    <p className={`${styles.title} ${styles['title--mobile']}`}>
                      {x.node.nameMobile}
                    </p>
                  )}
                </div>
                {x.node?.style === 'icons' || x.node?.style === 'elettrico' ? (
                  <div
                    className={`${styles.iconImageBox} ${
                      !!x.node.style ? styles[`iconImageBox--${x.node.style}`] : ''
                    }`}
                  >
                    {x.node?.style === 'icons' ? (
                      <ScenarioPalazziIllustration />
                    ) : (
                      <HeroElettricoIllustration />
                    )}
                  </div>
                ) : (
                  <>
                    <div
                      className={`${styles.imageBox} ${
                        x.node.imageMobile ? styles['imageBox--desktop'] : ''
                      }
                      ${site === NUOVAMOBILITA ? styles['imageBox--nuovamobilita'] : ''}`}
                    >
                      <WImage
                        src={x.node.image}
                        alt={x.node.name}
                        title={x.node.name}
                        maxWidth={1920}
                        maxHeight={473}
                        layout="fill"
                        objectFit="cover"
                      />
                    </div>
                    {!!x.node.imageMobile && (
                      <div className={`${styles.imageBox} ${styles['imageBox--mobile']}`}>
                        <WImage
                          src={x.node.imageMobile}
                          alt={x.node.name}
                          title={x.node.name}
                          maxWidth={767}
                          maxHeight={473}
                          layout="fill"
                          objectFit="cover"
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default Hero
